import * as Yup from 'yup';
import { Messages, ValidationErrors } from '@efacity/common';

export const additionalSessionOptionFormValuesValidationSchema = Yup.object().shape({
  name: Yup.string().required(Messages.NameRequired),
  description: Yup.string(),
  price: Yup.number().min(0, ValidationErrors.PriceIsRequired),
  expiresOn: Yup.date().required(Messages.ExpiredOnRequired)
});
